@if (!rows.length) {
  <p class="empty">Aucune facture ni aucun avoir sur cette ligne.</p>
} @else {
  <table class="ledger-table">
    <thead>
      <tr>
        <th>Pièce</th>
        <th>Date</th>
        <th class="num">Rangs</th>
        <th>Du – au (inclus)</th>
        <th class="num">Qté</th>
        <th class="num">PU HT</th>
        <th class="num">HT</th>
        <th class="num">TTC</th>
        <th>Reports et corrections</th>
      </tr>
    </thead>
    <tbody>
      @for (r of rows; track r.key) {
        <tr [class.credit]="r.credit" [attr.data-line]="r.key">
          <td class="piece">
            <small>{{ r.type }}</small>
            @if (r.link !== null) {
              <a [routerLink]="['/sales/quotation', r.link]" target="_blank" [matTooltip]="'Ouvrir la pièce' + (r.state ? ' (' + r.state + ')' : '')">{{ r.ref }}</a>
            } @else {
              <span class="inert">{{ r.ref }}</span>
            }
          </td>
          <td class="date">{{ r.date }}</td>
          <td class="num">{{ r.ranks }}</td>
          <td class="span">{{ r.span }}</td>
          <td class="num">{{ r.qty }}</td>
          <td class="num" [matTooltip]="r.lpp">{{ r.pu }}</td>
          <td class="num">{{ r.ht }}</td>
          <td class="num">{{ r.ttc }}</td>
          <td class="notes">
            @for (n of r.notes; track $index) {
              <span>{{ n }}</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
